import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { OrganizationExtRouter } from './organization.router';
import { reducers } from './state/organization.selectors';

@NgModule({
  imports: [
    OrganizationExtRouter,
    StoreModule.forFeature('organization', reducers),
  ],
  declarations: []
})
export class OrganizationExtScreenModule { }